export default function initModals() {
    (function ($) {

        // Function to load the modal content dynamically via AJAX
        function loadModalContent(modalId) {
            const globalLoader = $('#globalLoader'); // Show global loader (if you have one)
            globalLoader.show();

            // Make the AJAX request
            $.ajax({
                url: my_ajax_object.ajax_url, // AJAX URL from localized script
                type: 'POST',
                data: {
                    action: 'load_modal_content', // The action name
                    modal_id: modalId, // Pass the modal ID
                    nonce: my_ajax_object.nonce.load_modal_content_nonce // Use the correct nonce key for modals
                },
                success: function (response) {
                    globalLoader.hide();

                    if (response.success) {
                        const modalData = response.data;
                        const modalContent = `
                        ${generateGallery(modalData.gallery)}
                        <div class="modal__text">
                            <p class="subtitle-1 modal__subtitle">${modalData.subtitle}</p>
                            <h2 class="modal__title">${modalData.title}</h2>
                              ${modalData.content}
                        </div>
                        <div class="modal__buttons">
                            <a href="${modalData.btn_link}" class="btn modal__register ${modalData.btn_styles}">${modalData.btn_text}</a>
                                        <a class="close-btn modal__close_btn btn btn-white-border">Uždaryti</a>
                        </div>
                    `;
                        $('#ModalContent').html(modalContent); // Insert content into modal
                        $('#Modal').show(); // Show the modal

                        // Optionally, initialize gallery slider if applicable
                        initializeSplideGallery();
                        disableBodyScroll();
                    } else {
                        console.error('Error loading modal content:', response.data);
                    }
                },
                error: function (xhr, status, error) {
                    globalLoader.hide();
                    console.error('AJAX Error:', error);
                }
            });
        }

        // Function to generate the gallery HTML
        function generateGallery(images) {
            let galleryHtml = '';
            if (images && images.length > 0) {
                galleryHtml = `<div class="splide modal__gallery"><div class="splide__track"><ul class="splide__list">`;
                images.forEach(function (image) {
                    galleryHtml += `<li class="splide__slide"><img src="${image.url}" alt="${image.alt}" /></li>`;
                });
                galleryHtml += `</ul></div></div>`;
            }
            return galleryHtml;
        }

        // Initialize Splide gallery slider (if applicable)
        function initializeSplideGallery() {
            const gallery = $('#Modal .modal__gallery');
            if (gallery.length > 0) {
                new Splide('#Modal .modal__gallery', {
                    type: 'loop',
                    perPage: 1,
                    pagination: false,
                    arrows: true,
                    easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
                }).mount();
            }
        }

        // Open modal on button click (triggered by data-modal-id)
        $('body').on('click', '.modal-btn', function (e) {
            e.preventDefault();
            const modalId = $(this).data('modal-id'); // Get the modal ID from button
            loadModalContent(modalId); // Load content for that modal
        });

        // Close modal when clicking the close button
        $('body').on('click', '.close-btn', function () {
            $('#Modal').hide(); // Hide the modal
            $('#ModalContent').empty(); // Empty the modal content
            enableBodyScroll(); // Re-enable scrolling
        });

        // Close modal when clicking outside modal content
        $('body').on('click', '#Modal', function (e) {
            if (!$(e.target).closest('.modal__content').length) {
                $('#Modal').hide();
                enableBodyScroll();
            }
        });

        // Disable body scroll when modal is open
        function disableBodyScroll() {
            document.body.style.overflow = 'hidden';
        }

        // Enable body scroll when modal is closed
        function enableBodyScroll() {
            document.body.style.overflow = '';
        }
    })(jQuery);
}
